import { Link } from "react-router-dom";
import { TestPackagePage } from "@/pages/TestPackagePage";

const FAQS = [
  {
    q: "What does the AWARE Bore 360 include?",
    a: "The AWARE Bore 360 is designed specifically for bore water users. It analyses E. coli, Coliforms, pH, conductivity, TDS, and additional indicators relevant to bore water — helping you understand water quality concerns and whether treatment may be required.",
  },
  {
    q: "Is my bore water safe to drink?",
    a: "Bore water quality varies from property to property — it depends on the local aquifer, your bore depth, and the surrounding land use. The AWARE Bore 360 gives you the information you need to make an informed decision. Your plain-English summary will explain what each result means.",
  },
  {
    q: "Can I use this test for irrigation or livestock water?",
    a: "Yes — the AWARE Bore 360 is appropriate for drinking, domestic, irrigation and livestock applications. Where corrective treatment is recommended, you'll receive practical guidance in your report.",
  },
  {
    q: "How is bore water testing different from tank water testing?",
    a: "Bore water often has higher mineral and metal content than rainwater, and behaves very differently in plumbing and treatment systems. The AWARE Bore 360 focuses on indicators that matter for groundwater — hardness, conductivity, TDS, plus the bacterial screening parameters.",
  },
  {
    q: "Do you service my area?",
    a: "Local sample drop-off is available at our Noosaville laboratory and we accept posted / courier samples from customers Australia-wide where supported. See the Service Areas page for local drop-off suburbs, or contact the lab if you're unsure about your area.",
  },
];

export default function EssentialBoreWaterTestPage() {
  return (
    <TestPackagePage
      testId="bore"
      seo={{
        title: "AWARE Bore 360 | Bore Water Testing Australia-wide",
        description:
          "Bore water testing from Aware Water Testing — supporting customers Australia-wide. E. coli, coliforms, pH, conductivity, TDS and bore-specific indicators. Plain-English reports. Local drop-off in Noosaville.",
        urlPath: "/aware-bore-360",
      }}
      intro={{
        h1: "AWARE Bore 360",
        lede:
          "Bore water testing for Australian properties — identify common quality concerns and treatment requirements with a package built specifically for groundwater supplies.",
      }}
      whoFor={
        <>
          The AWARE Bore 360 is designed for property owners who rely on bore water — whether for drinking, domestic use, irrigation, or livestock. Bore water quality depends heavily on the local aquifer and land use, so we test a panel of indicators tailored to groundwater. You&rsquo;ll receive a Certificate of Analysis plus a plain-English summary explaining your results and any treatment considerations. New to groundwater supplies? Our{" "}
          <Link
            to="/bore-water-testing"
            data-testid="bore360-bore-landing-link"
            className="text-cyan-700 font-semibold underline underline-offset-2 hover:text-cyan-800"
          >
            bore water testing
          </Link>{" "}
          guide explains what can be tested and how the process works.
        </>
      }
      faqs={FAQS}
    />
  );
}
